import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getDirectoryContents, getDriveSectionContent, getDrivesForSection, setDirectoryActive, setSectionContentActive } from 'actions/onedrive';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { FileList, Spinner } from 'UI';
import { Button } from '@haldor/ui';

var OneDrivePicker = /*#__PURE__*/function (_Component) {
  _inherits(OneDrivePicker, _Component);

  var _super = _createSuper(OneDrivePicker);

  function OneDrivePicker(props) {
    var _this;

    _classCallCheck(this, OneDrivePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeDirectory", function (id, force) {
      var _this$state = _this.state,
          sharepoint = _this$state.sharepoint,
          sharepointDrive = _this$state.sharepointDrive;
      var section = _this.props.section;
      var _this$props$onedrive = _this.props.onedrive,
          activeContent = _this$props$onedrive.activeContent,
          fetchedFolders = _this$props$onedrive.fetchedFolders;
      var foundObject = fetchedFolders.find(function (dir) {
        if (id != null) {
          return dir.id === id;
        } else {
          return dir.id === sharepointDrive.id;
        }
      });

      if (typeof foundObject === 'undefined' || force) {
        // We need to get this directory from the API
        _this.setState({
          isLoading: true
        });

        if (sharepoint) {
          _this.props.getDriveSectionContent(section.graphId, sharepointDrive.id, id, function (data) {
            _this.setState({
              isLoading: false
            });
          });
        } else {
          _this.props.getDirectoryContents(id, function () {
            _this.setState({
              isLoading: false
            });
          });
        }
      } else {
        if (sharepoint) {
          if (foundObject.id == sharepointDrive.id) {
            _this.props.setSectionContentActive(sharepointDrive.id, null);
          } else {
            _this.props.setSectionContentActive(sharepointDrive.id, foundObject.id);
          }
        } else {
          _this.props.setDirectoryActive(foundObject.id);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goRoot", function () {
      _this.onChangeDirectory('root');
    });

    _defineProperty(_assertThisInitialized(_this), "onSharePointFolder", function (file) {
      if (file.folder) {
        _this.onChangeDirectory(file.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectFile", function (file) {
      if (file.folder) {
        _this.onChangeDirectory(file.id);
      } else {
        var selectedFiles = _this.state.selectedFiles;
        var foundObject = selectedFiles.findIndex(function (selF) {
          return selF.id == file.id;
        });

        if (foundObject !== -1) {
          // File got unselected
          selectedFiles.splice(foundObject, 1);
        } else {
          // File got selected
          selectedFiles.push(file);
        }

        _this.setState({
          selectedFiles: selectedFiles
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(_this.state.selectedFiles);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDriveClick", function (drive) {
      _this.setState({
        sharepoint: true,
        sharepointDrive: drive
      }, function () {
        _this.onChangeDirectory();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateCurrentFolder", function () {
      var activeContent = _this.props.onedrive.activeContent;

      _this.onChangeDirectory(activeContent.id, true);
    });

    _defineProperty(_assertThisInitialized(_this), "setSharepointMode", function () {
      _this.setState({
        sharepoint: !_this.state.sharepoint
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setOneDriveMode", function () {
      _this.setState({
        sharepoint: false
      }, function () {
        _this.goRoot();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFileList", function () {
      var _this$props$onedrive2 = _this.props.onedrive,
          activeContent = _this$props$onedrive2.activeContent,
          activeFolders = _this$props$onedrive2.activeFolders,
          sectionContent = _this$props$onedrive2.sectionContent;
      var _this$state2 = _this.state,
          sharepoint = _this$state2.sharepoint,
          isLoading = _this$state2.isLoading;

      if (sharepoint) {
        return /*#__PURE__*/React.createElement("div", null, isLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          medium: true,
          center: true
        })) : sectionContent !== null ? sectionContent.files.length > 0 ? /*#__PURE__*/React.createElement(FileList, {
          files: sectionContent.files,
          selectedFiles: _this.state.selectedFiles,
          onFolderClick: _this.onSharePointFolder,
          onFileClick: _this.onSelectFile
        }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, _this.props.translate('no-files'))) : null);
      } else {
        return /*#__PURE__*/React.createElement("div", null, isLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          medium: true,
          center: true
        })) : activeContent != null ? activeContent.files.length > 0 ? /*#__PURE__*/React.createElement(FileList, {
          files: activeContent.files,
          selectedFiles: _this.state.selectedFiles,
          onFolderClick: _this.onSelectFile,
          onFileClick: _this.onSelectFile
        }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, _this.props.translate('no-files'))) : null);
      }
    });

    _this.state = {
      selectedFiles: [],
      isLoading: false,
      sharepoint: false,
      sharepointDrive: null
    };
    return _this;
  }

  _createClass(OneDrivePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.goRoot();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.section && nextProps.section !== this.props.section) {
        this.props.getDrivesForSection(nextProps.section.graphId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Define Onedrive constants from the state
      var _this$props$onedrive3 = this.props.onedrive,
          activeContent = _this$props$onedrive3.activeContent,
          activeFolders = _this$props$onedrive3.activeFolders,
          sectionDrives = _this$props$onedrive3.sectionDrives;
      var _this$state3 = this.state,
          isLoading = _this$state3.isLoading,
          sharepoint = _this$state3.sharepoint,
          sharepointDrive = _this$state3.sharepointDrive;
      var section = this.props.section;
      return /*#__PURE__*/React.createElement("div", {
        className: "onedrive-picker"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sidebar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "directory-breadcrumb"
      }, /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, /*#__PURE__*/React.createElement("strong", null, "OneDrive"), /*#__PURE__*/React.createElement("div", {
        className: "sidebar-item",
        onClick: this.setOneDriveMode
      }, "Filer"), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })), section ? sectionDrives == null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      })) : /*#__PURE__*/React.createElement("div", null, sectionDrives.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, /*#__PURE__*/React.createElement("strong", null, section.title), sectionDrives.map(function (drive) {
        return /*#__PURE__*/React.createElement("div", {
          onClick: function onClick(e) {
            _this2.onDriveClick(drive);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "sidebar-item"
        }, drive.name), /*#__PURE__*/React.createElement("div", {
          style: {
            clear: 'both'
          }
        }));
      })) : /*#__PURE__*/React.createElement("div", null, "Det finns inga drives i denna grupp")) : null)), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "directory-breadcrumb"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pull-left"
      }, sharepoint ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement("strong", null, section.title), sharepointDrive ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, "\xA0>\xA0", /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          _this2.onDriveClick(sharepointDrive);
        }
      }, sharepointDrive.name)) : null) : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement("strong", null, "OneDrive"), "\xA0>\xA0", /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          _this2.onSelectFile({
            folder: true,
            id: 'root'
          });
        }
      }, this.props.translate('files'))), activeFolders.length > 0 ? activeFolders.map(function (activeFolder) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'inline-block'
          }
        }, "\xA0>\xA0", /*#__PURE__*/React.createElement("span", {
          key: "one-head-".concat(activeFolder.id),
          onClick: function onClick(e) {
            _this2.onSelectFile(activeFolder);
          }
        }, activeFolder.name));
      }) : null), /*#__PURE__*/React.createElement(Button, {
        style: {
          "float": 'right'
        },
        onClick: this.updateCurrentFolder,
        className: "c--button secondary"
      }, this.props.translate('refresh')), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })), /*#__PURE__*/React.createElement("div", null, this.renderFileList())));
    }
  }]);

  return OneDrivePicker;
}(Component);

function mapStateToProps(state) {
  return {
    onedrive: state.onedrive,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getDirectoryContents: getDirectoryContents,
  setDirectoryActive: setDirectoryActive,
  getDrivesForSection: getDrivesForSection,
  getDriveSectionContent: getDriveSectionContent,
  setSectionContentActive: setSectionContentActive
})(OneDrivePicker);